(function (Drupal, $, once) {
  Drupal.behaviors.popularPages = {
    attach: function (context) {
      $(function () {
        once('popular-pages-title', '.popular-pages__title').forEach(function (element) {
          $(element).on("click", function () {
            if (!window.matchMedia("(min-width: 1024px)").matches) {
              $(this).toggleClass("is-open");
              $(this)
                .siblings(".popular-pages__links")
                .stop()
                .slideToggle(300);
            }
          });
        });
      });
    },
  };
})(Drupal, jQuery, once);
